import { Content, Title, InputFormTable, HtmlContent } from 'components';
import { Checkbox } from 'antd';
import styles from '../styles';

const ProductDeliveryInformation = ({ data }) => {
  const getPropertyValue = (isForwarding, property, defaultValue) => {
    if (data) {
      if (isForwarding) {
        if (data.forwarding_location && data.forwarding_location[property]) {
          return data.forwarding_location[property];
        }
      } else {
        if (data[property]) {
          return data[property];
        }
      }
    }

    return defaultValue;
  };

  const getPackageMethod = (packageMethod) => {
    if (packageMethod === 'GENERAL') {
      return '일반';
    } else if (packageMethod === 'REFRIGERATION') {
      return '냉장';
    } else if (packageMethod === 'FREEZING') {
      return '냉동';
    }
  };

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>배송 정보</Title>
      <InputFormTable
        labelWidth={160}
        form={[
          {
            label: '묶음배송 가능 여부',
            form: [
              {
                input: (
                  <>
                    <Checkbox
                      size="large"
                      disabled
                      checked={
                        getPackageMethod(false, 'is_bundle_delivery', 'N') ===
                        'Y'
                          ? true
                          : false
                      }
                    >
                      묶음배송 불가능 (상품별 배송비 적용)
                    </Checkbox>
                  </>
                ),
              },
            ],
          },
          {
            label: '배송 템플릿',
            form: [
              {
                input: (
                  <>
                    <span>{getPropertyValue(true, 'forwarding_name', '')}</span>
                  </>
                ),
              },
            ],
          },
          {
            label: '스토어 픽업 여부',
            form: [
              {
                input: (
                  <>
                    <span>
                      {getPropertyValue(false, 'is_store_pickup', '') === 'Y'
                        ? '픽업함'
                        : '픽업안함'}
                    </span>
                  </>
                ),
              },
            ],
          },
          {
            label: '출고일 설정',
            form: [
              {
                input: (
                  <>
                    <span>
                      {getPropertyValue(false, 'forwarding_date', '0')} 일 이후
                      출고
                    </span>
                  </>
                ),
              },
            ],
          },
          {
            label: '포장 방식',
            form: [
              {
                input: (
                  <>
                    <span>
                      {getPackageMethod(
                        getPropertyValue(false, 'packaging_method', '')
                      )}
                    </span>
                  </>
                ),
              },
            ],
          },
          {
            label: '출고 안내사항',
            form: [
              {
                input: (
                  <div style={{ width: '850px', height: '250px' }}>
                    <HtmlContent
                      content={getPropertyValue(
                        false,
                        'forwarding_information',
                        ''
                      )}
                    />
                  </div>
                ),
              },
            ],
          },
        ]}
      />
    </Content>
  );
};

export default ProductDeliveryInformation;
